// import "./home.css";
import { useNavigate } from "react-router-dom";
import { FaCrown } from "react-icons/fa";

const PromotionNavigation = () => {
  const navigate = useNavigate();

  return (
    <div className="main">
      <div id="Sportbook">
        <div className="container bg-color-sportbook custom-card4">
          <div className="inner-space1">
            <div className="row">
              <div className="col-md-12">
                <h2 className="mb-4">Promotion Control Panel</h2>
                <p className="custom-card4p">
                  Select the Promotions
                </p>
              </div>
            </div>
            <div className="row" style={{ backgroundColor: '#fff', padding: '5px 0px 20px 0px' }}>
              <div className="col-md-8 mx-auto">
                <div className="row">

                  <div className="col-md-3" onClick={() => navigate("/wheel-of-fortune")}>
                    <div className="card-box">
                      <FaCrown style={{fontSize:"60px"}}/>
                      <h4>WOF Configuration</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/monthly-promotions")}>
                    <div className="card-box">
                      <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Monthly Promotions</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/MarketingPopup")}>
                    <div className="card-box">
                      <FaCrown style={{fontSize:"60px"}}/>
                      <h4>User Popup</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/promotion-config")}>
                    <div className="card-box">
                      <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Streak Promotion Config</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/popup-offers")}>
                    <div className="card-box">
                      <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Pop-up Offers</h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/promo-campaigns")}>
                    <div className="card-box">
                      <FaCrown style={{fontSize:"60px"}}/>
                      <h4>Promo Codes</h4>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionNavigation;
